<template>
  <UApp>
    <AppLayout>
      <NuxtPage />
    </AppLayout>
  </UApp>
</template>
